import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=5482e380&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=5482e380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482e380",
  null
  
)

export default component.exports